import ExtensionPage from '@/components/Pages/ExtensionPage';

export default ExtensionPage;
